/**
 * @generated SignedSource<<7c0b477ffadb6355d0c5691686fe30b9>>
 * @relayHash acbb0f32edd74c3ab4aa948e9f8c4fbe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4553bd2eed646d9e7628e63cbebaf4d350a92fb1e74a197fc4dba4667d1e154a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CalendarContentQuery } from './CalendarContentQuery.graphql';

const node: PreloadableConcreteRequest<CalendarContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4553bd2eed646d9e7628e63cbebaf4d350a92fb1e74a197fc4dba4667d1e154a",
    "metadata": {},
    "name": "CalendarContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
